import React from "react";
import { AppDownloadIcon } from "../../Icon/AppDownloadIcon";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const DownloadButton = (props: IAppButtonProps) => (
    <AppButton
        variant="contained"
        startIcon={<AppDownloadIcon />}
        {...props}
    >
        {props.children}
    </AppButton>
);
